import { ReactNode } from "react";

import DashboardIcon from "@mui/icons-material/Dashboard";
import ApiIcon from "@mui/icons-material/Api";
import ListAltIcon from "@mui/icons-material/ListAlt";
import LogoutIcon from "@mui/icons-material/Logout";

export interface MenuItem {
	link?: string;
	icon?: ReactNode;
	badge?: string;
	items?: MenuItem[];
	name: string;
}

export interface MenuItems {
	items: MenuItem[];
	heading: string;
}

const menuItems: MenuItems[] = [
	{
		heading: "",
		items: [
			{
				name: "User Approval",
				link: "/app",
				icon: DashboardIcon,
			},
			{
				name: "User Log",
				link: "/log",
				icon: ListAltIcon,
			},
			{
				name: "Data Path",
				link: "/data",
				icon: ListAltIcon,
			},
			{
				name: "Worksheet Full",
				link: "/intworksheetfull",
				icon: ListAltIcon,
			},
			{
				name: "Worksheet Missing",
				link: "/worksheet5",
				icon: ListAltIcon,
			},
		],
	},
	{
		heading: "Log Out",
		items: [
			{
				name: "Log Out",
				link: "/logout",
				icon: LogoutIcon,
			},
		],
	},
];

export const menuItems1: MenuItems[] = [
	{
		heading: "",
		items: [
			{
				name: "Profile",
				link: "/dashboards/crypto",
				icon: DashboardIcon,
			},
		],
	},
	{
		heading: "Reports",
		items: [
			{
				name: "Data Sheet",
				link: "/datasheet",
				icon: ApiIcon,
			},
			{
				name: "Work Sheet",
				link: "/worksheet",
				icon: ListAltIcon,
			},
			{
				name: "PF TDS Worksheet",
				link: "/tdsworksheet",
				icon: ListAltIcon,
			},
			{
				name: "Pension Worksheet",
				link: "/intworksheet",
				icon: ListAltIcon,
			},
			{
				name: "Worksheet Full",
				link: "/intworksheetfull",
				icon: ListAltIcon,
			},
			{
				name: "Worksheet Detailed",
				link: "/intworksheetdet",
				icon: ListAltIcon,
			},
			{
				name: "Intrest Calculators",
				link: "/worksheet5",
				icon: ListAltIcon,
			},
		],
	},
	{
		heading: "Log Out",
		items: [
			{
				name: "Log Out",
				link: "/logout",
				icon: LogoutIcon,
			},
		],
	},
];

export default menuItems;
